import { NgModule } from '@angular/core';
import { AppManagerComponent } from './app-manager.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppManagerComponent, DialogComponent
  ],
  imports: [
    CommonModule,MatListModule,MatIconModule,RouterModule,MatButtonModule,MatDialogModule,
    MatDialogModule,FormsModule,
    TranslateModule.forRoot()
  ],
  exports: [
    AppManagerComponent
  ]
})
export class AppManagerModule { }
